var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"full-screen"},[_c(_vm.props.components.Header,{tag:"Header"}),_c(_vm.props.components.HeaderView,{tag:"HeaderView"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }